import React from 'react';
import './Banner.css';

import { Button, Heading } from '../../../components';



const Banner = () => {

  return (
    <section className="banner">
      <div className='content'>

        <Heading 
          title={"Power Your Future with Clean Solar Energy"} 
          subTitle={"Sustainable Energy Solutions"} 
          linear 
          sideHeading 
        />
        <Button 
          link={"Services"} 
          title={"Get Started"} 
        />

      </div>
    </section>

  );

};

export default Banner;